import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import companyToken from "Utils/companyToken";
import { prepareHeadersWithCSRFToken } from "Utils/fetchWithCSRFToken";
import { convertDataToFormDataFormat } from "Utils/formDataHelpers";

import { BenAdminOpenEnrollmentSetup } from "../types";
import { appendAuthParams } from "Common/TokenAuth/Utils";

type UpdateArgs = {
  medicalDocuments: File[];
  medicalRates: File[];
  dentalDocuments: File[];
  dentalRates: File[];
  visionDocuments: File[];
  visionRates: File[];
  lifeDocuments: File[];
  lifeRates: File[];
  longTermDisabilityDocuments: File[];
  longTermDisabilityRates: File[];
  shortTermDisabilityDocuments: File[];
  shortTermDisabilityRates: File[];
};

export const benAdminOpenEnrollmentSetupApi = createApi({
  reducerPath: "benAdminOpenEnrollmentSetupApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v2/",
    prepareHeaders: prepareHeadersWithCSRFToken,
  }),

  endpoints: (builder) => ({
    getBenAdminOpenEnrollmentSetup: builder.query<BenAdminOpenEnrollmentSetup, null>({
      query: () => {
        const companyIDToken = companyToken();
        const data = {
          ...(companyIDToken ? { company_id_token: companyIDToken } : {}),
        };
        const params = new URLSearchParams(data).toString();
        return appendAuthParams(`/ben_admin_open_enrollment_setup?${params}`);
      },
      providesTags: ["BenAdminOpenEnrollmentSetup"],
    }),
    updateBenAdminOpenEnrollmentSetup: builder.mutation<BenAdminOpenEnrollmentSetup, UpdateArgs>({
      query: (values) => {
        const companyIDToken = companyToken();
        return {
          url: appendAuthParams("/ben_admin_open_enrollment_setup"),
          method: "PUT",
          body: convertDataToFormDataFormat({
            benAdminOpenEnrollmentSetup: values,
            ...(companyIDToken ? { company_id_token: companyIDToken } : {}),
          }),
        };
      },
      invalidatesTags: ["BenAdminOpenEnrollmentSetup"],
    }),
  }),
  tagTypes: ["BenAdminOpenEnrollmentSetup"],
});

export const { useGetBenAdminOpenEnrollmentSetupQuery, useUpdateBenAdminOpenEnrollmentSetupMutation } = benAdminOpenEnrollmentSetupApi;
